import {Spinner, Message} from '../../index'
import {
    // dynamicInputSelect,
    inputCheckBox,
    inputText,
    staticInputSelect,
} from '../../../utils/dynamicForm';
import inputGridOfEntriesBlock from './planogramFormMachines';

export const FormMachines = ({
                                 edit,
                                 formCleanHandler,
                                 isLoading,
                                 register,
                                 isError,
                                 errors,
                                 watch,
                                 setValue,
                                 isLoadingUpdate,
                                 isLoadingPost,
                                 handleSubmit,
                                 submitHandler,
                                 triggerReset,
                                 error,
                                 dataProducts,
                                 // dataMachines,
                             }) => {

    // console.log(getDefaultCategoryOptions());
    // const categoryOptions = getDefaultCategoryOptions().map((option, index) => ({
    //   ...option,
    //   key: index.toString(),
    // }));
    //     console.log('dataMachines');
    // console.log(dataMachines);

    return (
        <div
            className='modal fade'
            id='machineModal'
            data-bs-backdrop='static'
            data-bs-keyboard='false'
            tabIndex='-1'
            aria-labelledby='machineModalLabel'
            aria-hidden='true'
        >
            <div className='modal-dialog'>
                <div className='modal-content modal-background'>
                    <div className='modal-header'>
                        <h3 className='modal-title ' id='machineModalLabel'>
                            {edit ? 'Edit Machines' : 'Add a NEW Machine'}
                        </h3>
                        <button
                            type='button'
                            className='btn-close'
                            data-bs-dismiss='modal'
                            aria-label='Close'
                            onClick={formCleanHandler}
                        ></button>
                    </div>
                    <div className='modal-body'>
                        {isLoading ? (
                            <Spinner/>
                        ) : isError ? (
                            <Message variant='danger'>{error}</Message>
                        ) : (
                            <form onSubmit={handleSubmit(submitHandler)}>
                                <div className='machine-info form-group-block'>
                                    <div className='machine-info-title form-group-title'>Info</div>

                                    {inputText({
                                        register,
                                        errors,
                                        label: 'Kiosk External ID',
                                        name: 'kiosk_external_id',
                                        placeholder: '',
                                        isRequired: true,
                                    })}
                                    {inputText({
                                        register,
                                        errors,
                                        label: 'Friendly Name',
                                        name: 'machine_name',
                                        placeholder: '',
                                        isRequired: true,
                                    })}
                                    {inputText({
                                        register,
                                        errors,
                                        label: 'Phone',
                                        name: 'machine_phone',
                                        placeholder: '',
                                        isRequired: false,
                                    })}
                                    {inputText({
                                        register,
                                        errors,
                                        label: 'Erp Client ID',
                                        name: 'erp_id',
                                        placeholder: '',
                                        isRequired: false,
                                    })}
                                    {inputText({
                                        register,
                                        errors,
                                        label: 'Erp Token',
                                        name: 'erp_token',
                                        placeholder: '',
                                        isRequired: false,
                                    })}
                                    {inputText({
                                        register,
                                        errors,
                                        label: 'Erp Document Series',
                                        name: 'erp_doc_series',
                                        placeholder: '',
                                        isRequired: false,
                                    })}
                                </div>

                                {/*{inputTextArea({*/}
                                {/*    register,*/}
                                {/*    errors,*/}
                                {/*    label: 'Items',*/}
                                {/*    name: 'items',*/}
                                {/*    placeholder: '',*/}
                                {/*    isRequired: false,*/}
                                {/*})}*/}
                                <div className='machine-planogram form-group-block'>
                                    <div className='machine-planogram-title form-group-title'>Planogram</div>

                                    {inputGridOfEntriesBlock({
                                        setValue,
                                        errors,
                                        watch,
                                        register,
                                        label: 'Items',
                                        name: 'items',
                                        placeholder: '',
                                        isRequired: false,
                                        dataProducts,
                                        triggerReset
                                        // initialValue: watch('items'),
                                    })}
                                </div>

                                {/*{inputTextArea({*/}
                                {/*    register,*/}
                                {/*    errors,*/}
                                {/*    label: 'Items Errors',*/}
                                {/*    name: 'items_errors',*/}
                                {/*    placeholder: '',*/}
                                {/*    isRequired: false,*/}
                                {/*})}*/}
                                {/*{inputTextArea({*/}
                                {/*    register,*/}
                                {/*    errors,*/}
                                {/*    label: 'Pre Items',*/}
                                {/*    name: 'pre_items',*/}
                                {/*    placeholder: '',*/}
                                {/*    isRequired: false,*/}
                                {/*})}*/}
                                {/*{inputTextArea({*/}
                                {/*    register,*/}
                                {/*    errors,*/}
                                {/*    label: 'Post Items',*/}
                                {/*    name: 'post_items',*/}
                                {/*    placeholder: '',*/}
                                {/*    isRequired: false,*/}
                                {/*})}*/}
                                {/*{inputTextArea({*/}
                                {/*    register,*/}
                                {/*    errors,*/}
                                {/*    label: 'Pre Items Errors',*/}
                                {/*    name: 'pre_items_errors',*/}
                                {/*    placeholder: '',*/}
                                {/*    isRequired: false,*/}
                                {/*})}*/}
                                {/*{inputTextArea({*/}
                                {/*    register,*/}
                                {/*    errors,*/}
                                {/*    label: 'Post Items Errors',*/}
                                {/*    name: 'post_items_errors',*/}
                                {/*    placeholder: '',*/}
                                {/*    isRequired: false,*/}
                                {/*})}*/}

                                <div className='integration-options form-group-block'>
                                    <div className='integration-options-title form-group-title'>Integration Options
                                    </div>

                                    {staticInputSelect({
                                        register,
                                        errors,
                                        label: 'Type',
                                        name: 'machineType',
                                        data: [{name: 'master'}, {name: 'master-slave'}, {name: 'slave'}],
                                        placeholder: '',
                                        isRequired: false,
                                    })}
                                    {inputCheckBox({
                                        register,
                                        errors,
                                        watch,
                                        name: 'machineToAdminInventory',
                                        label: 'Update Inventory from Machine',
                                        isRequired: false,
                                        placeholder: 'Confirmed',
                                    })}
                                    {inputCheckBox({
                                        register,
                                        errors,
                                        watch,
                                        name: 'machineToAdminPlanogram',
                                        label: 'Update Planogram from Machine',
                                        isRequired: false,
                                        placeholder: 'Confirmed',
                                    })}
                                </div>

                                <div className='machine-kiosk form-group-block'>
                                    <div className='machine-kiosk-title form-group-title'>Kiosk Options</div>
                                    {staticInputSelect({
                                        register,
                                        errors,
                                        label: 'Payment Options',
                                        name: 'payment_options',
                                        data: [{name: 'card'}, {name: 'card-cash'}, {name: 'cash'}],
                                        placeholder: '',
                                        isRequired: false,
                                    })}
                                    {inputCheckBox({
                                        register,
                                        errors,
                                        watch,
                                        name: 'qr_code_receipt',
                                        label: 'QR Code Receipt',
                                        isRequired: false,
                                        placeholder: 'Confirmed',
                                    })}
                                </div>
                                <div className='machine-status form-group-block'>
                                    <div className='machine-status-title form-group-title'>Status</div>

                                    {inputText({
                                        register,
                                        errors,
                                        label: 'machine status',
                                        name: 'machine_status',
                                        placeholder: '',
                                        isRequired: false,
                                    })}
                                    {inputText({
                                        register,
                                        errors,
                                        label: 'machine order id processing',
                                        name: 'machine_order_id_processing',
                                        placeholder: '',
                                        isRequired: false,
                                    })}

                                    {inputCheckBox({
                                        register,
                                        errors,
                                        watch,
                                        name: 'confirmed',
                                        label: 'Confirmed',
                                        isRequired: false,
                                        placeholder: 'Confirmed',
                                    })}
                                    {inputCheckBox({
                                        register,
                                        errors,
                                        watch,
                                        name: 'blocked',
                                        label: 'Blocked',
                                        isRequired: false,
                                        placeholder: 'Blocked',
                                    })}

                                </div>

                                <div className='modal-footer'>
                                    <button
                                        type='button'
                                        className='btn btn-secondary '
                                        data-bs-dismiss='modal'
                                        onClick={formCleanHandler}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type='submit'
                                        className='btn btn-primary '
                                        disabled={isLoadingPost || isLoadingUpdate}
                                    >
                                        {isLoadingPost || isLoadingUpdate ? (
                                            <span className='spinner-border spinner-border-sm'/>
                                        ) : (
                                            'Submit'
                                        )}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FormMachines
